import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import TitledPanel from '../../core/TitledPanel';
import Deprecated from '../../core/Deprecated';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from '../../core/AddButton';
import PrimaryButton from '../../core/PrimaryButton';
import SearchSelect from '../../core/SearchSelect';
import { globalStyles } from '../../core/style/gstheme';
import { getGraphFromProject } from '../../core/utils/utils';

const styles = Object.assign({
}, globalStyles);

class FindPropertyDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            lang: props.defaultLang
        };
        this.cancellable = null;
    }

    handleClickOpen = () => this.setState({ open: true });

    computeSearch = (value, lang) => {
        let graph = this.props.projects.map(project => getGraphFromProject(project));
        const propsExclusions = this.props.exclude ? this.props.exclude : [];
        let search = [
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: [
                    "http://www.w3.org/2002/07/owl#ObjectProperty",
                    "http://www.w3.org/2002/07/owl#AnnotationProperty",
                    "http://www.w3.org/2002/07/owl#DatatypeProperty"
                ]
            }
        ];
        if (value !== "") {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label",
                value: value,
                isExactMatch: false
            });
        }
        else {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label"
            });
        }
        let fullSearch =
        {
            search,
            graph,
            basicSort: true,
            exclude: [
                ...propsExclusions,
                "https://graphifi.com/schema/xowl/topAnnotationProperty",
                "http://www.w3.org/2002/07/owl#topObjectProperty",
                "http://www.w3.org/2002/07/owl#topDataProperty"
            ],
            ...(this.props.excludeByPath) && {
                excludeByPath: this.props.excludeByPath
            },
            language: lang,
            ignoreNoLanguage: lang !== "und",
            pageSize: 100,
            predicates: [
                "http://www.w3.org/2000/01/rdf-schema#label",
                "http://www.w3.org/2002/07/owl#deprecated",
                "http://www.w3.org/2000/01/rdf-schema#domain",
                "http://www.w3.org/2000/01/rdf-schema#range"
            ],
            sort: "http://www.w3.org/2000/01/rdf-schema#label"
        };
        return fullSearch;
    };

    addProperty = (id) => {
        // Check for incoming addition
        if (!this.props.exclude || !this.props.exclude.includes(id)) {
            this.props.onAddProperty(id);
        }
    };

    exitAddProperty = () => this.setState({ open: false, lang: this.props.defaultLang });

    changeLanguage = (lang) => this.setState({ lang });

    render() {

        const { classes, exclude } = this.props;
        const { lang } = this.state;

        return (
            <React.Fragment>
                <AddButton dataTest="add-ontology-property" onClick={() => this.handleClickOpen()} title="Add properties" />
                <Dialog
                    data-test="add-ontology-property-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog} open={this.state.open}
                    onClose={this.exitAddProperty} aria-labelledby="find-property-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="find-property-dialog-title">Add Properties</DialogTitle>
                    <DialogContent style={{ height: 450 }}>
                        <div style={{ height: 350 }}>
                            <TitledPanel title="Language">
                                <ProjectLanguageSelector selectedLang={lang} includeLabel={false} onSelect={this.changeLanguage} />
                            </TitledPanel>
                            <SearchSelect
                                key={lang}
                                dataTest="find-property"
                                focus={true}
                                sortProp="label"
                                wrapped={true}
                                exclude={exclude}
                                search={(value, lang) => this.computeSearch(value, lang)}
                                listSecondIcon={(result) => {
                                    if (result.deprecated) return <Deprecated />;
                                    return null;
                                }}
                                listDisplay={(result, lang) => {
                                    const domain = result.domain ? <span className={classes.domainRange}><span className={classes.drTitle}>Domain</span> {result.domain.join(", ")}</span> : null;
                                    const range = result.range ? <span className={classes.domainRange}><span className={classes.drTitle}>Range</span> {result.range.join(", ")}</span> : null;
                                    if (result.label[lang]) {
                                        return <div>
                                            <Typography data-test="result-label" variant="body2">
                                                <Tooltip placement="left" title={result.id}>
                                                    <span>
                                                        {result.label[lang]}
                                                    </span>
                                                </Tooltip>
                                            </Typography>
                                            <div>{domain}{range}</div>
                                        </div>;
                                    }
                                    else {
                                        return <Typography data-test="result-label" variant="body2">{result.id}</Typography>;
                                    }
                                }}
                                isClickableResult={(result) => !result.invalid && !result.deprecated}
                                title="Filter properties"
                                lang={lang}
                                chosen={this.addProperty} />
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <PrimaryButton onClick={this.exitAddProperty} >Close</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

FindPropertyDialog.defaultProps = {
    exclude: []
};

FindPropertyDialog.propTypes = {
    classes: PropTypes.object,
    projects: PropTypes.array.isRequired,
    exclude: PropTypes.array,
    excludeByPath: PropTypes.array,
    onAddProperty: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(FindPropertyDialog);